export const fr = {
    'buttons': {
        'return': 'Retour'
    },
    'selects': {
        'currency': {
            'label': 'Devise',
            'placeholder': 'Choisissez une devise',
            'options-title': 'Liste des monnaies disponibles'
        },
        'currency-and-network': {
            'placeholder': 'Choisissez une devise et un réseau',
            'options-title': 'Liste des monnaies disponibles'
        },
        'selected-label': 'Sélectionné : {selected} sur {length}',
        'search': 'Rechercher',
        'errors': {
            'invalid': 'Valeur invalide',
            'required': 'Requis',
            'card-holder': 'Entrez le prénom et le nom du titulaire de la carte',
            'input-amount': 'Entrez le montant',
            'fill-card': 'Renseignez les informations de la carte'
        },
        'empty-list': 'Liste vide',
        'address': {
            'label': 'Adresse de retrait en {currency}',
            'options-title': 'Liste des adresses disponibles'
        },
        'cardholder-input': {
            'placeholder': 'Titulaire de la carte'
        }
    },
    'text-fields': {
        'labels': {
            'personal': {
                'address': 'Votre adresse pour le dépôt'
            },
            'invoice': {
                'address': 'Adresse',
                'paid-amount': 'Montant payé'
            }
        }
    },
    'labels': {
        'deposit': 'Dépôt',
        'withdraw': 'Retrait',
        'currency': 'Devise',
        'amount': 'Montant',
        'invoice': {
            'remaining-time': 'Temps restant pour payer',
            'status': {
                'expires': 'Temps écoulé',
                'success': 'Paiement réussi',
                'error': 'Erreur'
            },
            'partially-paid': {
                'title': 'Partiellement payé',
                'info': 'Le montant a été partiellement payé. Le montant restant doit être payé pour que le paiement soit réussi.'
            },
            'orphan': {
                'title': 'Transaction orpheline',
                'description': 'Lune des transactions de cette commande contient un réseau ou une devise incorrecte.',
                'contact': 'Contactez le support technique avec l ID :'
            },
            'you-paid': 'Vous avez payé',
            'active-order': 'Commande active',
            'new-invoice': 'Nouvelle facture',
            'order-id': 'ID de la facture',
            'payment-amount': 'Montant du paiement'
        },
        'continue': 'Continuer',
        'payout': {
            'address': 'Adresse de retrait en {currency}',
            'tag-or-memo': 'TAG ou MEMO',
            'status': {
                'processed': 'Réussi',
                'error': 'Erreur',
                'orphan': 'Transaction orpheline',
                'approve_rejected': 'Rejeté',
                'in-progress': 'En cours',
                'need-approve': 'Nécessite une approbation',
                'awaiting-confirmation': 'Votre demande de retrait est en attente de confirmation'
            },
            'info': {
                'withdraw-id': 'ID du retrait',
                'tx-hash': 'TX hash',
                'currency-and-network': 'Devise et réseau',
                'address': 'Adresse',
                'tag-or-memo': 'TAG ou MEMO',
                'amount': 'Montant à retirer'
            }
        },
        'fiat': {
            'title': 'Dépôt via fiat',
            'info': {
                'amount': 'Montant',
                'date': 'Date du paiement',
                'id': 'ID du dépôt',
                'system': 'Système de paiement'
            },
            'status': {
                'new': 'Nouveau',
                'pending': 'En attente',
                'authorized': 'Autorisé',
                'confirmed': 'Confirmé',
                'reconciled': 'Rapproché',
                'error': 'Erreur',
                'declined': 'Refusé'
            }
        }
    },
    'errors': {
        'wrong-widget-id': 'ID de widget incorrect',
        'wrong-ext-user-id': 'ID utilisateur externe incorrect',
        '404': 'Oups ! Nous avons cherché mais nous navons pas trouvé ce que vous recherchez.',
        'without-xt-user-id-withdrawal': 'Retrait indisponible. Le paramètre extUserId nest pas transmis',
        'without-xt-user-id-deposit': 'Dépôt indisponible. Le paramètre extUserId nest pas transmis'
    },
    'invoice': {
        'order': 'Commande',
        'inputs': {
            'email': {
                'label': 'Adresse e-mail',
                'placeholder': 'Entrez votre adresse e-mail'
            },
            'amount': {
                'label': 'Montant',
                'placeholder': 'Entrez le montant'
            }
        },
        'text-fields': {
            'expanded': {
                'in-usd': 'Montant en',
                'rate': 'Taux de change',
                'payment-id': 'ID de paiement',
                'description': 'Description'
            }
        },
        'order-public-link': {
            'do-not-refresh': "Ne rafraîchissez pas la page ni n'ouvrez dans un",
            'new-tab': 'nouvel onglet'
        },
        'statuses': {
            'ERROR': 'ERREUR',
            'PENDING': 'EN ATTENTE',
            'PROCESSED': 'TRAITÉ',
            'REJECTED': 'REJETÉ',
            'OVERPAID': 'TROP PAYÉ',
            'CREATED': 'CRÉÉ',
            'PARTIAL': 'PARTIELLEMENT PAYÉ',
            'INIT': 'INITIÉ',
            'EXPIRED': 'EXPIRÉ'
        }
    },
    'personal': {
        'titles': {
            'deposit': 'Dépôt',
            'payment-history': 'Historique des paiements'
        },
        'payment-history': {
            'empty-label': 'Toutes vos transactions envoyées à l adresse indiquée seront disponibles ici',
            'headers': {
                'date': 'Date et heure',
                'amount': 'Montant',
                'tx': 'Tx_hash',
                'status': 'Statut'
            },
            'statuses': {
                'processed': 'Traitée',
                'pending': 'En attente',
                'rejected': 'Rejetée',
                'error': 'Erreur'
            },
            'in': 'dans'
        },
        'qr-block': {
            'empty-label': 'Recharge en cryptomonnaie',
            'qr-info-pre-invoice': "Envoyez uniquement",
            'qr-info-pre-personal': "Envoyez n'importe quel montant uniquement à",
            'qr-info-post': 'à cette adresse',
            'qr-info-minimal': 'Les transferts de moins de 1 USD ne sont pas crédités'
        }
    },
    'fiat': {
        'titles': {
            'deposit': 'Dépôt via fiat',
            'payment-history': 'Historique des paiements'
        },
        'labels': {
            'pay': 'Payer',
            'service-commission': 'Montant de la commission de service',
            'total': 'Total',
            'you-pay': 'Vous payez'
        }
    },
    'popup': {
        'orphan-danger': {
            'title': 'Transaction orpheline',
            'info': 'Lune des transactions de cette commande contient un réseau ou une devise incorrecte.',
            'support': 'Contactez le support technique avec l ID'
        }
    },
    'cookie-policy': {
        'by-clicking': 'En cliquant sur le bouton « Continuer », vous acceptez automatiquement',
        'our': 'notre politique relative aux cookies'
    },
    'payout': {
        'payout': 'Paiement',
        'output': 'Retrait',
        'withdraw': 'Retrait',
        'errors': {
            'wrong-address': 'L adresse n appartient pas au réseau {network}'
        }
    }
}
